import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { FileShortSummary } from '@savgroup-front-common/types';
import { useGetFileStatesQuery } from '@/view/app/hooks/Workflow/useGetFileStatesQuery';

import { PROFESSIONAL_STEP_CONFIG } from '../../../../../app/NewLayout/ProfessionalRoutes.config';
import { buildProfessionalRoute } from '../../../../../app/NewLayout/ProfessionalRoutes.helpers';
import { MultiProductInfo } from '../../components/MultiProductInfo/MultiProductInfo';

interface HomePageFileItemProps {
  file: FileShortSummary;
}

const HomePageFileItem: FC<HomePageFileItemProps> = ({ file }) => {
  const navigate = useNavigate();
  const { histories, isLoading: isLoadingHistories } = useGetFileStatesQuery({
    fileId: file.fileId,
  });

  const handleFileClick = useCallback(() => {
    navigate(
      buildProfessionalRoute({
        route: PROFESSIONAL_STEP_CONFIG.PROFESSIONAL_FILE_FOLLOWUPS_PAGE,
        payload: {
          fileId: file.fileId,
        },
      }),
    );
  }, [file.fileId, navigate]);

  if (isLoadingHistories) {
    return null;
  }

  return (
    <MultiProductInfo
      file={file}
      histories={histories}
      onClick={handleFileClick}
    />
  );
};

export default HomePageFileItem;
